var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "a",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("activate", _vm.currentNumber.id)
            }
          }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              disabled: !_vm.canEdit,
              href: _vm.getHref("dashboard.numbers.edit", {
                numberId: _vm.currentNumber.id
              }),
              "data-testid": "number-edit-btn"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("on-edit", _vm.currentNumber)
              }
            }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("NUMBERS_ACTIONS_EDIT"),
                  expression: "$t('NUMBERS_ACTIONS_EDIT')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-edit",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "NUMBERS_ACTIONS_EDIT",
                  expression: "'NUMBERS_ACTIONS_EDIT'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-icon" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-list-function",
            attrs: {
              href: "javascript:;",
              disabled: !_vm.canDelete,
              "data-testid": "number-delete-btn"
            },
            on: {
              click: function($event) {
                return _vm.$emit("on-delete", _vm.currentNumber)
              }
            }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right.hover",
                  value: _vm.$t("NUMBERS_DEALLOCATE"),
                  expression: "$t('NUMBERS_DEALLOCATE')",
                  modifiers: { right: true, hover: true }
                }
              ],
              staticClass: "typcn typcn-trash"
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "NUMBERS_DEALLOCATE",
                  expression: "'NUMBERS_DEALLOCATE'"
                }
              ],
              staticClass: "hint-text-mobile"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.pauseAvailable
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: !_vm.canPause },
                on: {
                  click: function($event) {
                    return _vm.$emit("on-pause", _vm.currentNumber)
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left.hover",
                      value: _vm.$t("NUMBERS_ACTIONS_PAUSE"),
                      expression: "$t('NUMBERS_ACTIONS_PAUSE')",
                      modifiers: { left: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-media-pause",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PAUSE",
                      expression: "'PAUSE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.enableAvailable
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                on: {
                  click: function($event) {
                    return _vm.$emit("on-enable", _vm.currentNumber)
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left.hover",
                      value: _vm.$t("NUMBERS_ACTIONS_ENABLE"),
                      expression: "$t('NUMBERS_ACTIONS_ENABLE')",
                      modifiers: { left: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-media-play",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ENABLE",
                      expression: "'ENABLE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          "is-disabled": _vm.disabled,
          "object-id": _vm.currentNumber.id,
          "object-name": _vm.currentNumber.phoneNumber,
          "object-type": "number"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }